import Vue from "vue";
import Vuex from "vuex";
import permissionModules from "./modules/permission.js";
// import VuexPersistence from "vuex-persist";

// // 2.添加配置项
// const vuexLocal = new VuexPersistence({
//   storage: window.localStorage,
// });
import VuexPersist from "vuex-persist";

const vuexLocalStorage = new VuexPersist({
  key: "my-app",
  storage: window.sessionStorage,
  autoRehydrate: true,
});

Vue.use(Vuex);
export default new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  state: {
    // 角色
    roles: [],
    // routes:[45,6]
    menustatus: 0,
    // menustatus: localStorage.getItem("menustatus"),
    inputstatus: 0,
    rolesname:[],
    name:'',
    page:1,
    page1:1,
    total:'',
    searchConditions: {} // 存储搜索条件
  },

  mutations: {
    setPage(state, val) {
        state.page = val;
    },
    setPage1(state, val) {
      state.page1 = val;
  },
    setmenustatus(state, status) {
      state.menustatus = status;
    },
    setroles(state, status) {
      state.rolesname = status;
    },
    setinputstatus(state, status) {
      state.inputstatus = status;
    },

    loginName(state, nike) {
      state.name = nike;
    },
    MessageTotal(state, total) {
      state.total = total;
    },
    addSearchCondition(state, { type, condition }) {
      state.searchConditions[type] = condition;
    },
    removeSearchConditions(state, type) {
      delete state.searchConditions[type];
    },
    
  },

  actions: {
    saveSearchCondition({ commit }, { type, condition }) {
      commit('addSearchCondition', { type, condition });
    },
    clearSearchConditions({ commit }, type) {
      commit('removeSearchConditions', type);
    },
    
  },


  modules: {

    permission: {
      namespaced: true,
      ...permissionModules,
    },
  },
});
